import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FreeFormAgendaService } from '../service/free-form-agenda.service';

@Pipe({
  name: 'safeAgneda'
})
export class SafeAgnedaPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer,private commonAgService:FreeFormAgendaService) { }

  transform(agList:any) {
    return this.constructAgSec(agList);
  }
  //Method to construct agenda section
  constructAgSec(agList:any){
    var tempHtml ="<br>";
    if(agList!=null && agList!=undefined){
      tempHtml = agList.agendaTitle;
      if(agList.agendaPresenterList?.length){
        tempHtml+='&nbsp;<span class="presentedByCls" contenteditable="false">Presented by&nbsp;</span>';
        agList.agendaPresenterList.forEach((agPresenterList: any, index: any) => {
          tempHtml+='<span class="atwho-inserted" data-atwho-at-query="@" id="'+agPresenterList.presenterUserId+'" fkuserid="'+agPresenterList.presenterUserId+'" contenteditable="false">'+agPresenterList.presenterName;
          ////consolee.log("lengh>>>"+agList.agendaPresenterList?.length+"an cond>>>"+index)
          if((agList.agendaPresenterList?.length>1) && (index!=agList.agendaPresenterList?.length-1)){
            tempHtml+=",";
          }
          tempHtml+="</span>&nbsp;";
        });
      }
      if(agList.agendaDuration!=null && agList.agendaDuration!=undefined && agList.agendaDuration!="0" && agList.agendaDuration!=0){
        tempHtml+='<span class="agDurCls" data-original-title="" title="" contenteditable="false" ><span class="agDurLabelCls">[ </span>'+agList.agendaDuration+'<span class="agDurLabelCls"> Minutes ]</span></span>&nbsp;';
      }
    }
    return this.sanitized.bypassSecurityTrustHtml(tempHtml);
  }

}
